<div class="row">
  <div class="col">


    <div class="main-card mb-3 card">
      <div class="card-body">
      

        <div class="box-header text-center">
          <h3 class="box-title">PTs com Status Aberto</h3><br />
          <span  *ngIf="this.pts?.length > 0">Selecione para editar</span>
        </div>




        <div class="box-body">

          <div class="box-table h500" *ngIf="this.pts?.length > 0">

            <table>
              <thead>
                <tr>
                  <th>Nº PT</th>
                  <th>Requisitante</th>
                  <th>Data Cadastro</th>
                  <th>Ramal</th>
                  <th>{{labelCentroCusto}}</th>
                  <th>Cadastrado por</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pt of pts" (click)="editar(pt?.id)" class="cp">
                  <td class="text-center">{{ pt?.id | zerosEsquerda : 5}}</td>
                  <td>{{ pt?.requisitante }}</td>
                  <td class="text-center">{{ pt?.dataHoraCadastro | date:'dd/MM/yyyy' }}</td>
                  <td class="text-center">{{ pt?.contato }}</td>
                  <td class="text-center">{{ pt?.centroCusto }}</td>
                  <td>{{ pt?.usuarioSolicitou }}</td>
                </tr>
                <tr *ngFor="let v of this.voids">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          
            <div class="no-results mt-5 h450" *ngIf="this.pts !== undefined && this.pts?.length == 0">
              <div class="swal2-icon swal2-success swal2-animate-success-icon">
                <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
                <span class="swal2-success-line-tip"></span><span class="swal2-success-line-long"></span>
                <div class="swal2-success-ring"></div>
                <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
                <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
              </div>
              <div class="results-subtitle">No momento</div>
              <div class="results-title">Nenhum PT com status aberto</div>
            </div>


         
        </div>

        <div class="box-footer">
          <span *ngIf="this.pts !== undefined && this.pts?.length > 0"
            class="pl-2 pt-1 pb-2">Total PTs: <b>{{ this.pts?.length  }}</b></span>
        </div>

      </div>
    </div>

  </div>
</div>

 <div class="row">
  <div class="col-md-12">
    <div class="box box-primary box-dark">
      <div class="box-body">

        <div class="d-flex justify-content-center">
          <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq-dark.png" /></a>
        </div>

      </div>
    </div>
  </div>
</div>